import React, { useState } from "react";
import { motion, AnimatePresence, color } from "framer-motion";
import {
  FiMoreVertical,
  FiEdit,
  FiTrash2,
  FiCheckCircle,
  FiXCircle,
  FiEye,
} from "react-icons/fi";
import { toast } from "react-toastify";

const MenuItem = ({ icon, text, color, hoverBg, onClick }) => (
  <motion.button
    whileHover={{
      scale: 1.04,
      backgroundColor: hoverBg,
      x: 6,
    }}
    whileTap={{ scale: 0.96 }}
    className="dropdown-item"
    onClick={onClick}
    style={{
      display: "flex",
      alignItems: "center",
      gap: 12,
      width: "100%",
      padding: "14px 20px",
      background: "white",
      border: "none",
      textAlign: "left",
      fontSize: "15px",
      fontWeight: "500",
      cursor: "pointer",
      color: color === "danger" ? "#dc2626" : "#1e293b",
    }}
  >
    <span style={{ fontSize: "18px" }}>{icon}</span>
    <span>{text}</span>
  </motion.button>
);

const AboutPageActionsDropdown = ({ content, onEdit, refreshList, onView }) => {
  const [open, setOpen] = useState(false);
  const token = localStorage.getItem("accessToken");

  const callAction = async (action) => {
    const messages = {
      confirm: "Tasdiqlansinmi?",
      cancel: "Bu kontent bekor qilinsinmi?",
      delete: "Haqiqatan o'chirilsinmi?",
    };

    if (!window.confirm(messages[action])) return;

    try {
      let url = "";
      let method = "PUT";

      if (action === "confirm")
        url = `/api/admin/AboutPage/Confirm/${content.id}`;
      else if (action === "cancel")
        url = `/api/admin/AboutPage/Cancel/${content.id}`;
      else if (action === "delete") {
        url = `/api/admin/AboutPage/Delete/${content.id}`;
        method = "DELETE";
      }

      const response = await fetch(`https://algoritm-api-edu.uz${url}`, {
        method,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok || response.status === 204) {
        toast.success(
          action === "confirm"
            ? "Tasdiqlandi!"
            : action === "cancel"
            ? "Bekor qilindi!"
            : "O'chirildi!"
        );
        refreshList();
      } else {
        const errorText = await response.text();
        console.error("Server xatosi:", response.status, errorText);
        toast.error(
          action === "cancel" && response.status === 400
            ? "Hozircha bekor qilib bo'lmaydi"
            : "Amal bajarilmadi"
        );
      }
    } catch (err) {
      toast.error("Internet bilan aloqa yo'q");
    } finally {
      setOpen(false);
    }
  };

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <motion.button
        whileHover={{ scale: 1.15 }}
        whileTap={{ scale: 0.9 }}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((v) => !v);
        }}
        style={{
          background: "rgba(255,255,255,0.8)",
          border: "1px solid #e2e8f0",
          borderRadius: "8px",
          padding: "6px 8px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 100,
        }}
        aria-label="Amallar"
      >
        <FiMoreVertical size={20} color="#64748b" />
      </motion.button>

      <AnimatePresence>
        {open && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              style={{
                position: "fixed",
                inset: 0,
                zIndex: 9997,
              }}
              onClick={() => setOpen(false)}
            />

            <motion.div
              initial={{ opacity: 0, scale: 0.85, y: -20, rotateX: -15 }}
              animate={{ opacity: 1, scale: 1, y: 0, rotateX: 0 }}
              exit={{ opacity: 0, scale: 0.85, y: -20, rotateX: -15 }}
              transition={{
                type: "spring",
                stiffness: 400,
                damping: 30,
                duration: 0.3,
              }}
              style={{
                position: "absolute",
                top: "110%",
                right: 0,
                background: "white",
                borderRadius: "16px",
                boxShadow: "0 20px 50px rgba(0,0,0,0.2)",
                overflow: "hidden",
                zIndex: 9999,
                minWidth: "210px",
                border: "1px solid #e2e8f0",
              }}
            >
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.0 }}
              >
                <MenuItem
                  icon={<FiEye color="#4f46e5" />}
                  text="Ko‘rish"
                  hoverBg="#eef2ff"
                  onClick={() => {
                    if (onView) onView();
                    setOpen(false);
                  }}
                />
              </motion.div>
              <div>
                {content.displayStatus !== "Confirmed" &&
                  content.displayStatus != null && (
                    <motion.div
                      initial={{ opacity: 0, x: -30 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: 0.05 }}
                    >
                      <MenuItem
                        icon={<FiCheckCircle color="#16a34a" />}
                        text="Tasdiqlash"
                        hoverBg="#f0fdf4"
                        onClick={() => callAction("confirm")}
                      />
                    </motion.div>
                  )}

                {content.displayStatus === "Confirmed" && (
                  <motion.div
                    initial={{ opacity: 0, x: -30 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.1 }}
                  >
                    <MenuItem
                      icon={<FiXCircle color="#d97706" />}
                      text="Bekor qilish"
                      hoverBg="#fffbeb"
                      onClick={() => callAction("cancel")}
                    />
                  </motion.div>
                )}

                {content.displayStatus !== "Confirmed" && (
                  <>
                    <motion.div
                      initial={{ opacity: 0, x: -30 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: 0.15 }}
                    >
                      <MenuItem
                        icon={<FiEdit color="#2563eb" />}
                        text="Tahrirlash"
                        hoverBg="#eff6ff"
                        onClick={() => {
                          onEdit();
                          setOpen(false);
                        }}
                      />
                    </motion.div>

                    <motion.div
                      initial={{ opacity: 0, x: -30 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: 0.2 }}
                    >
                      <MenuItem
                        icon={<FiTrash2 color="#dc2626" />}
                        text="O‘chirish"
                        hoverBg="#fee2e2"
                        onClick={() => callAction("delete")}
                      />
                    </motion.div>
                  </>
                )}
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default React.memo(AboutPageActionsDropdown);
